import React, { useContext, useEffect, useMemo } from "react"
import { Children } from "../../../../../../../components/miscellianous/children"
import { BSBuilding } from "../../../../../../../core/dto/beem-shot/BSBuilding/BSBuilding"
import { BSBuildingResult } from "../../../../../../../core/dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { BSMaterialResultDashboard } from "../../../../../../../core/dto/beem-shot/BSMaterialResult/BSMaterialResultDashboard"
import { BSMorphology } from "../../../../../../../core/dto/beem-shot/BSMorphology/BSMorphology"
import { BSVariantDashboardDto } from "../../../../../../../core/dto/beem-shot/BSVariant/BSVariantDashboardDto"
import { useDashboardVariant } from "./useDashboardVariant"
import { VariantListDashboardContext } from "./VariantListDashboardContext"

export const Variant1Context = React.createContext<Variant1Store>({} as Variant1Store)

export function Variant1ContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { bsVariants, isLoaded } = useContext(VariantListDashboardContext)

  const {
    bsVariant: variant1,
    selectVariant: selectVariant1,
    bsBuilding: bsBuilding1,
    isBuildingLoading: isBuildingLoading1,
    bsBuildingResult: bsBuildingResult1,
    isBuildingResultLoading: isBuildingResultLoading1,
    bsMaterialResultList: bsMaterialResultList1,
    bsMorphology: bsMorphology1,
    bimModelFile: bimModelFile1,
  } = useDashboardVariant()

  useEffect(() => {
    if (isLoaded && bsVariants.length > 1) {
      selectVariant1(bsVariants[0])
    }
  }, [bsVariants, isLoaded, selectVariant1])

  const variant1Store = useMemo(
    () => ({
      variant1,
      selectVariant1,
      bsBuilding1,
      isBuildingLoading1,
      bsBuildingResult1,
      isBuildingResultLoading1,
      bsMaterialResultList1,
      bsMorphology1,
      bimModelFile1,
    }),
    [
      bsBuilding1,
      bsBuildingResult1,
      isBuildingLoading1,
      isBuildingResultLoading1,
      selectVariant1,
      variant1,
      bsMaterialResultList1,
      bsMorphology1,
      bimModelFile1,
    ]
  )

  return <Variant1Context.Provider value={variant1Store}>{children}</Variant1Context.Provider>
}

export interface Variant1Store {
  variant1: BSVariantDashboardDto | undefined
  bsBuilding1: BSBuilding | undefined
  isBuildingLoading1: boolean
  bsBuildingResult1: BSBuildingResult | undefined
  isBuildingResultLoading1: boolean
  bsMaterialResultList1: BSMaterialResultDashboard[]
  bsMorphology1: BSMorphology | undefined
  selectVariant1(bsVariant: BSVariantDashboardDto): void
  bimModelFile1: File | undefined
}
